<template>
  <div class="bgc">
    <div class="register_content">
      <h2>hecoos</h2>
      <p>
        To ensure that you can pass the audit quickly, please fill in the true
        and effective information.
      </p>
      <div class="input-group">
        <input type="text" placeholder="Name" v-model="form.rname" />
        <input type="text" placeholder="Company" v-model="form.company" />
      </div>
      <div class="phone-verify-group">
        <div class="phone-verify-container">
          <input
            class="phone-input"
            type="email"
            placeholder="E-mail"
            v-model="form.email"
          />
          <button
            :disabled="!isPhoneValid || isCountingDown"
            @click="obtainCode"
            class="verify-code-button"
          >
            {{ isCountingDown ? `${countdown}s` : "Get" }}
          </button>
        </div>
        <input
          type="text"
          placeholder="Verify code"
          v-model="form.verifyCode"
          class="verify-input"
        />
      </div>
      <div class="input-group">
        <input type="password" placeholder="Password" v-model="form.password" />
        <input
          type="password"
          placeholder="Re-enter password"
          v-model="form.confirmPassword"
        />
      </div>
      <div class="input-group">
        <input type="text" placeholder="City" v-model="form.city" />
        <input type="text" placeholder="Job" v-model="form.position" />
      </div>
      <div class="input-group">
        <select  placeholder="Seniority" :class="{'none_select' : !this.form.workDuration}" v-model="form.workDuration">
          <option value="" disabled selected>Seniority</option>
          <option v-for="item in workDurationList" :value="item.name">{{item.name}}</option>
        </select>
         <input 
           type="text" 
           placeholder="Referrer (optional)" 
           v-model="form.referrer" 
         /> 
      </div>
      <button :disabled="!isButtonEnabled" @click="goRegister">Submit</button>
      <div class="link-container">
        <span @click="jumpTo('/en')">Home Page</span>丨
        <span @click="jumpTo('/en/login')"
          >Already have an account ? Log in</span
        >
      </div>


    </div>
  </div>
</template>

<script>
import { getEnglishCaptcha, adminRegister } from "@/api/api";
import { Message } from "element-ui";
export default {
  data() {
    return {
      form: {
        rname: "",
        email: "",
        verifyCode: "",
        password: "",
        confirmPassword: "",
        company: "",
        city: "",
        position: "",
        workDuration: "",
        referrer: "",
      },
      isCountingDown: false,
      countdown: 60,
      errorMessages: [], // 新增：收集所有错误信息
      workDurationList:[
          {name:'1years'},
          {name:'2years'},
          {name:'3years'},
          {name:'4years'},
          {name:'5years'},
          {name:'6years'},
          {name:'7years'},
          {name:'8years'},
          {name:'9years'},
          {name:'More than 10 years'}
      ]
    };
  },
  computed: {
    isButtonEnabled() {
      return (
        // 所有必填字段都填写且密码一致
        this.form.rname &&
        this.form.email &&
        this.form.verifyCode &&
        this.form.password &&
        this.form.confirmPassword &&
        this.form.company &&
        this.form.city &&
        this.form.position &&
        this.form.workDuration &&
        this.form.password === this.form.confirmPassword
      );
    },
    isPhoneValid() {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailRegex.test(this.form.email);
    },
  },
  methods: {
    jumpTo(url) {
      this.$router.push(url);
    },
    // 获取验证码
    obtainCode() {
      // 先校验邮箱格式
      if (!this.isPhoneValid) {
        Message.error("Please enter the correct email format");
        return;
      }

      let postData = {
        email: this.form.email,
      };
      getEnglishCaptcha(postData).then((res) => {
        if (res.code === 200) {
          Message.success(res.message);
          this.startCountdown();
        } else {
          Message.error(res.message);
        }
      });
    },
    // 注册
    goRegister() {
      // 执行完整表单校验
      if (!this.validateForm()) {
        return;
      }

      adminRegister(this.form).then((res) => {
        if (res.code === 200) {
          Message.success(res.message);
          this.$router.push("/en/login");
        } else {
          Message.error(res.message);
        }
      });
    },
    startCountdown() {
      this.isCountingDown = true;
      let timer = setInterval(() => {
        this.countdown--;
        if (this.countdown === 0) {
          clearInterval(timer);
          this.isCountingDown = false;
          this.countdown = 60;
        }
      }, 1000);
    },

    // 姓名校验
    checkZh(str) {
      // ^[A-Za-z]+$ ：仅字母，至少 2 个字符
      let reg = /^[A-Za-z]{2,20}$/; 
      return reg.test(str);
    },

    // 公司名称校验
    checkZhCompany(str) {
     // 允许字母、空格、& . ( ) / - ，至少 2 个字符
     let reg = /^[A-Za-z&\/\.\(\) -]{2,}$/; 
  return reg.test(str);
    },

    // 验证码校验（假设为6位数字）
    checkVerifyCode(str) {
      let reg = /^\d{6}$/;
      return reg.test(str);
    },

    // 职位校验（至少2个字符，可以是中英文）
    checkPosition(str) {
      let reg = /^.{2,}$/;
      return reg.test(str);
    },
  // 密码校验
    checkPassword(str) {
      return str.length >= 6;
    },
    // 城市校验
    checkCity(str) {
      //允许字母、空格、'-'（如 New York、San Francisco）
      let reg = /^[A-Za-z -]{2,}$/; 
      return reg.test(str);
    },

    // 统一表单校验方法
    validateForm() {
      const errors = [];

      // 收集所有错误
      if (!this.form.rname.trim())
        errors.push("Please enter your name.");
      if (!this.isPhoneValid) errors.push("The email format is incorrect, please re-enter");

      if (this.form.verifyCode && !this.checkVerifyCode(this.form.verifyCode))
        errors.push("Please enter a 6-digit verification code");
      if (this.form.password && !this.checkPassword(this.form.password))
        errors.push("The password length should be at least 6 digits");
      if (this.form.password !== this.form.confirmPassword)
        errors.push("Entered passwords differ!");
      if (!this.form.company.trim())
        errors.push("Please enter your company.");
      if (!this.form.city.trim()) errors.push("Please enter the city");
      if (!this.form.position.trim())
        errors.push("Please enter your job");
      if (!this.form.workDuration)
        errors.push("Please choose seniority");

      // 延迟显示错误
      if (errors.length > 0) {
        errors.forEach((msg, index) => {
          setTimeout(() => {
            Message.error(msg);
          }, 500 * index);
        });
        return false;
      }

      return true;
    },


  },
};
</script>

<style lang="scss" scoped>
.bgc {
  display: flex;
  justify-content: center;
  align-items: center;
  background: url("https://download.hecoos.com/enlightv/2025-17/88bbd52c2dca3a58360b8aa5ad07d60d.png");
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 100vh;
}

.register_content {
  background-color: #222;
  width: 650px;
  padding: 30px 50px;
  border-radius: 15px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
  text-align: center;
  color: #fff;
}

.register_content h2 {
  margin-bottom: 20px;
  font-size: 32px;
}

.register_content p {
  margin-bottom: 30px;
  font-size: 20px;
}

.input-group {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.input-group input {
  width: 48%;
  padding: 15px;
  border: none;
  border-radius: 8px;
  background-color: #333;
  color: #fff;
  font-size: 18px;
}

.input-group select {
  width: 48%;
  padding: 15px;
  border: none;
  border-radius: 8px;
  background-color: #333;
  color: #fff;
  font-size: 18px;
}
.input-group select:focus-visible{
  border: none;
  outline: none;
}


.input-group select.none_select {
  color: #757575;
}
.phone-verify-group {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.phone-verify-container {
  display: flex;
  width: 48%;
  position: relative;
}

.phone-input {
  flex: 1;
  padding: 10px;
  padding-left: 14.5px;
  border: none;
  border-radius: 6px;
  background-color: #333;
  color: #fff;
  width: 100%; /* 明确设置宽度为100% */
  height: auto; /* 高度随内容自适应，和其他输入框保持一致 */
  font-size: 14px;
}
.phone-input::placeholder {
  font-size: 18px;
}

.verify-code-button {
  font-size: 18px;
  width: 80px;
  padding: 15px 10px; /* 调整按钮内边距 */
  background-color: #333;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  height: auto; /* 高度随内容自适应 */
  position: absolute;
  right: 0;
  top: 0;
  margin: 0;
  // left: 100px;
}

.verify-input {
  width: 48%;
  padding: 15px;
  border: none;
  border-radius: 8px;
  font-size: 18px;
  background-color: #333;
  color: #fff;
  height: auto; /* 高度随内容自适应 */
}

button {
  width: 100%;
  padding: 15px;
  border: none;
  border-radius: 8px;
  background-color: #fff;
  color: #222;
  cursor: pointer;
  margin-bottom: 20px;
  font-size: 18px;
}

button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.link-container {
  font-size: 18px;
  color: #fff;

  span {
    cursor: pointer;
  }
}
</style>
